export default "__VITE_ASSET__D$NNkKQl__"